module.exports = __webpack_public_path__ + "static/media/antelope@2x.800998a4.jpg";